import { t as e } from "./createLucideIcon-CJLgHpqc.js";
import "./calendar-BLyd2Htq.js";
var t = e("calendar", [
	["path", {
		d: "M8 2v4",
		key: "1cmpym"
	}],
	["path", {
		d: "M16 2v4",
		key: "4m81vk"
	}],
	["rect", {
		width: "18",
		height: "18",
		x: "3",
		y: "4",
		rx: "2",
		key: "1hopcy"
	}],
	["path", {
		d: "M3 10h18",
		key: "8toen8"
	}]
]);
//#endregion
export { t };

//# sourceMappingURL=calendar-Bk83OIIY.js.map